// extracted by mini-css-extract-plugin
export default {"root":"MloqMT4Q"};